module.exports = __webpack_public_path__ + "img/9.5.COD.24ae7720.png";